type Rect = { top: number; left: number; width: number; height: number };

const PADDING = 10;
const RADIUS = 8;

export function TourSpotlight({
  rect,
  reducedMotion,
}: {
  rect: Rect | null;
  reducedMotion: boolean;
}) {
  const vw = typeof window !== "undefined" ? window.innerWidth : 0;
  const vh = typeof window !== "undefined" ? window.innerHeight : 0;

  const transitionStyle = reducedMotion
    ? "none"
    : "x 600ms cubic-bezier(0.4, 0, 0.2, 1), y 600ms cubic-bezier(0.4, 0, 0.2, 1), width 600ms cubic-bezier(0.4, 0, 0.2, 1), height 600ms cubic-bezier(0.4, 0, 0.2, 1), opacity 300ms ease-out";

  const hasRect = rect !== null;
  const cutX = hasRect ? rect!.left - PADDING : vw / 2;
  const cutY = hasRect ? rect!.top - PADDING : vh / 2;
  const cutW = hasRect ? rect!.width + PADDING * 2 : 0;
  const cutH = hasRect ? rect!.height + PADDING * 2 : 0;

  return (
    <svg
      className="tour-spotlight"
      width={vw}
      height={vh}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9000,
        pointerEvents: "none",
      }}
      aria-hidden="true"
    >
      <defs>
        <mask id="tour-mask">
          <rect x="0" y="0" width={vw} height={vh} fill="white" />
          <rect
            x={cutX}
            y={cutY}
            width={cutW}
            height={cutH}
            rx={RADIUS}
            ry={RADIUS}
            fill="black"
            style={{ transition: transitionStyle, opacity: hasRect ? 1 : 0 }}
          />
        </mask>
      </defs>
      <rect
        x="0"
        y="0"
        width={vw}
        height={vh}
        fill="rgba(8, 7, 5, 0.72)"
        mask="url(#tour-mask)"
      />
      {hasRect && (
        <rect
          x={cutX}
          y={cutY}
          width={cutW}
          height={cutH}
          rx={RADIUS}
          ry={RADIUS}
          fill="none"
          stroke="rgba(138, 39, 56, 0.6)"
          strokeWidth="1.5"
          style={{ transition: transitionStyle }}
        />
      )}
    </svg>
  );
}
